// Senza dipendenze da i18next: lo importano anche routes.ts (config di React Router), gli script di build e worker.ts.
export const supportedLanguages = ['it', 'en'] as const
export type SupportedLanguage = (typeof supportedLanguages)[number]
export const defaultLanguage: SupportedLanguage = 'it'

export function isSupportedLanguage(value: string | undefined): value is SupportedLanguage {
  return (supportedLanguages as readonly string[]).includes(value ?? '')
}

/** La lingua è sempre il primo segmento dell'URL (/it/…, /en/…); altrimenti quella di default. */
export function langFromPath(pathname: string): SupportedLanguage {
  const segment = pathname.split('/')[1]
  return isSupportedLanguage(segment) ? segment : defaultLanguage
}
